let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dyn4Q")).then(() => parcelRequire('L00gy'));